import { ProcessFilterGroups } from '@components/GalleryComponents/GalleryPageContent/GalleryPageContent';
import { FilterGroups } from '@components/GalleryComponents/GalleryPageContent/GalleryPageContentFiltering';
import { useCallback } from 'react';

const WEDDING_WEBSITE_PRODUCT_TYPE = 'Wedding Website';

const _getTemplateImageUrl = (filename: string, version: string = '1638397480'): string =>
  `https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/new-websites/${filename}.jpg?v=${version}`;

//For tags, refer to `eCardCategorySlugsToTagsMap` in `src/utils/gallery.util.ts`

export const WEBSITE_TEMPLATE_GALLERY_CARDS: GalleryECard[] = [
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('charlotte-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Blue', 'White'],
    font: 'EB Garamond',
    variantColor: null,
    variantName: null,
    variantThemeId: 'charlotte',
    title: 'Charlotte',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#5D8EC6',
        pageBackground: '#5D8EC6',
        pageFont: '#FFFFFF',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Charlotte',
      themeId: 'charlotte',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('coastal-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Gray', 'Green'],
    font: 'WindSong',
    variantColor: null,
    variantName: null,
    variantThemeId: 'coastal',
    title: 'Coastal',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#E6ECEC',
        pageBackground: '#E6ECEC',
        pageFont: '#4D6A69',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Coastal',
      themeId: 'coastal',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('editorial_lime-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Green', 'Dark Green'],
    font: 'Cinzel',
    variantColor: null,
    variantName: null,
    variantThemeId: 'editorial_lime',
    title: 'Editorial Lime',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#C9E265',
        pageBackground: '#C9E265',
        pageFont: '#25520B',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Editorial Lime',
      themeId: 'editorial_lime',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('emilio_mocha-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Brown', 'White'],
    font: 'Forum',
    variantColor: null,
    variantName: null,
    variantThemeId: 'emilio_mocha',
    title: 'Emilio Mocha',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#A47764',
        pageBackground: '#A47764',
        pageFont: '#FFFFFF',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Emilio Mocha',
      themeId: 'emilio_mocha',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('gala_black-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Black', 'White'],
    font: 'Homemade Apple',
    variantColor: null,
    variantName: null,
    variantThemeId: 'gala_black',
    title: 'Gala Black',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#FBF3F0',
        pageBackground: '#FBF3F0',
        pageFont: '#000000',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Gala Black',
      themeId: 'gala_black',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('magazine_indigo-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Navy', 'Pink'],
    font: 'Viaoda Libre',
    variantColor: null,
    variantName: null,
    variantThemeId: 'magazine_indigo',
    title: 'Magazine Indigo',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#242E6B',
        pageBackground: '#242E6B',
        pageFont: '#DFA0AE',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Magazine Indigo',
      themeId: 'magazine_indigo',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('minimalist_arch-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Green', 'Beige'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'minimalist_arch',
    title: 'Minimalist Arch',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#6A725B',
        pageBackground: '#6A725B',
        pageFont: '#FBE7C1',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Minimalist Arch',
      themeId: 'minimalist_arch',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('modern_arch-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Pink', 'Black'],
    font: 'Viaoda Libre',
    variantColor: null,
    variantName: null,
    variantThemeId: 'modern_arch',
    title: 'Modern Arch',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#EDE0DB',
        pageBackground: '#EDE0DB',
        pageFont: '#000000',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Modern Arch',
      themeId: 'modern_arch',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('modern_lines_light-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Green', 'White'],
    font: 'WindSong',
    variantColor: null,
    variantName: null,
    variantThemeId: 'modern_lines_light',
    title: 'Modern Lines Light',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#69847F',
        pageBackground: '#69847F',
        pageFont: '#FFFFFF',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Modern Lines Light',
      themeId: 'modern_lines_light',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('newsstand_olive-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Green', 'Pink'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'newsstand_olive',
    title: 'Newsstand Olive',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#5F7200',
        pageBackground: '#5F7200',
        pageFont: '#FFC4D1',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Newsstand Olive',
      themeId: 'newsstand_olive',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('newsstand_taffy-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Blue', 'Pink'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'newsstand_taffy',
    title: 'Newsstand Taffy',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#006772',
        pageBackground: '#006772',
        pageFont: '#F9CFD8',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Newsstand Taffy',
      themeId: 'newsstand_taffy',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('queens_palace-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Navy', 'Gold'],
    font: 'Herr Von Muellerhoff',
    variantColor: null,
    variantName: null,
    variantThemeId: 'queens_palace',
    title: 'Queens Palace',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#101D3D',
        pageBackground: '#101D3D',
        pageFont: '#D9C891',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Queens Palace',
      themeId: 'queens_palace',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('regal_garden-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Beige', 'Black'],
    font: 'Pinyon Script',
    variantColor: null,
    variantName: null,
    variantThemeId: 'regal_garden',
    title: 'Regal Garden',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#F6F3ED',
        pageBackground: '#F6F3ED',
        pageFont: '#000000',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Regal Garden',
      themeId: 'regal_garden',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('rose_bed-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Black', 'Pink'],
    font: 'Gilda Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'rose_bed',
    title: 'Rosebed',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#000000',
        pageBackground: '#000000',
        pageFont: '#91787E',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Rosebed',
      themeId: 'rose_bed',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('rustic_chic-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Beige', 'Brown'],
    font: 'EB Garamond',
    variantColor: null,
    variantName: null,
    variantThemeId: 'rustic_chic',
    title: 'Rustic Chic',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#FCFBF7',
        pageBackground: '#FCFBF7',
        pageFont: '#82716D',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Rustic Chic',
      themeId: 'rustic_chic',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('sun_arch_iii-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Red', 'White'],
    font: 'Meddon',
    variantColor: null,
    variantName: null,
    variantThemeId: 'sun_arch_iii',
    title: 'Sun Arch III',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#953C2E',
        pageBackground: '#953C2E',
        pageFont: '#FFFFFF',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Sun Arch III',
      themeId: 'sun_arch_iii',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('tiffany_lilac-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Purple', 'Pink'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'tiffany_lilac',
    title: 'Tiffany Lilac',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#C8D4FC',
        pageBackground: '#C8D4FC',
        pageFont: '#DF217A',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Tiffany Lilac',
      themeId: 'tiffany_lilac',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('tiffany_red_ii-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['White', 'Red'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'tiffany_red_ii',
    title: 'Tiffany Red II',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#FFFFFF',
        pageBackground: '#FFFFFF',
        pageFont: '#EB4848',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Tiffany Red II',
      themeId: 'tiffany_red_ii',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('tiffany_red-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Red', 'White'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'tiffany_red',
    title: 'Tiffany Red',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#EB4848',
        pageBackground: '#EB4848',
        pageFont: '#FFFFFF',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Tiffany Red',
      themeId: 'tiffany_red',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('wavy_pink-v2'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Minimal'],
    colors: ['Pink', 'Red'],
    font: 'Seaweed Script',
    variantColor: null,
    variantName: null,
    variantThemeId: 'wavy_pink',
    title: 'Wavy Pink',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    websiteSettings: {
      colorPalette: {
        artBackground: '#F9DEEC',
        pageBackground: '#F9DEEC',
        pageFont: '#E45751',
      },
      pageTransparency: 'false',
      pageShadow: 'false',
      photoPresentationLayout: 'fullWidth',
      isBlankTemplate: true,
    },
    theme: {
      name: 'Wavy Pink',
      themeId: 'wavy_pink',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
];

const NEW_TEMPLATE_THEME_IDS = new Set(WEBSITE_TEMPLATE_GALLERY_CARDS.map((card) => card.theme.themeId));

function insertEveryNth(initialCards: MarketingData, cardsToInsert: MarketingData, interval: number, randomize?: boolean): MarketingData {
  const copiedCards = [...initialCards];
  const cards = randomize ? copiedCards.sort(() => Math.random() - 0.5) : copiedCards;
  let cardToInsertIndex = 0;
  let cardToInsert: GalleryECard | undefined = undefined;
  for (let i = 0; i < initialCards.length + Math.floor(initialCards.length / interval); i += interval) {
    cardToInsert = cardsToInsert[cardToInsertIndex++];
    if (!cardToInsert) {
      return cards;
    }
    cards.splice(i, 0, cardToInsert);
  }
  return cards;
}

export const insertNewTemplates = (initialCards: MarketingData): MarketingData => {
  return insertEveryNth(initialCards, WEBSITE_TEMPLATE_GALLERY_CARDS, 4, true);
};

export const processDesignFilterGroups: ProcessFilterGroups = (filterGroups, { hasFiltersApplied }): FilterGroups => {
  const { matchesWithNewTemplates, matchesWithoutNewTemplates } = filterGroups.match.reduce(
    (acc, card) => {
      acc[
        NEW_TEMPLATE_THEME_IDS.has(card.theme.themeId) && card.isComingSoon ? 'matchesWithNewTemplates' : 'matchesWithoutNewTemplates'
      ].push(card);
      return acc;
    },
    { matchesWithoutNewTemplates: [], matchesWithNewTemplates: [] } as {
      matchesWithoutNewTemplates: MarketingData;
      matchesWithNewTemplates: MarketingData;
    }
  );
  /**
   * When viewing save the date or invitation cards, prioritize joy printed themes
   */
  return {
    match: hasFiltersApplied
      ? insertEveryNth(matchesWithoutNewTemplates, matchesWithNewTemplates, 5, false)
      : insertEveryNth(filterGroups.match, WEBSITE_TEMPLATE_GALLERY_CARDS, 5, false),
    noMatch: filterGroups.noMatch,
  };
};
